export default __webpack_public_path__ + "static/media/phsa_logo.d8dee3cc.png";